/*
 * Layout utilities: slideshow arrows, cart sliders, order notes,
 * quantity handling, and free-shipping bar.
 */

/* ---- Slideshow arrow positioning ---- */
function sliderArrowPosition() {
  var slideshowWrappers = document.querySelectorAll('.slideshow-wrapper');

  slideshowWrappers.forEach(function (slideshowWrapper) {
    var slideshow = slideshowWrapper.querySelector('.slideshow.banner');
    var arrows = slideshowWrapper.querySelectorAll('.slider-arrow');
    var sliderHeight = slideshow?.querySelector('.slideshow__media')?.offsetHeight || 0;

    if (window.innerWidth < 750) {
      arrows.forEach(function (element) {
        element.style.top = sliderHeight / 2 + 'px';
      });
    } else {
      arrows.forEach(function (element) {
        element.style.top = '';
      });
    }
  });
}

function productImageDesktopArrow() {
  var mediaWrapper = document.querySelector('.product__media-wrapper');
  if (!mediaWrapper) return;

  var arrows = mediaWrapper.querySelectorAll('.slider-mobile-gutter .slider-arrow');
  arrows.forEach(function (arrow) {
    arrow.addEventListener('click', function () {
      var thumbnailWrapper = mediaWrapper.querySelector('.thumbnail-list');
      var currentButton = thumbnailWrapper.querySelector('.thumbnail-list__item button[aria-current="true"]');
      var direction = arrow.getAttribute('name');

      if (direction == 'next') {
        if (currentButton.parentElement.nextSibling) {
          currentButton.parentElement.nextSibling.querySelector('button').click();
        }
      } else {
        if (currentButton.parentElement.previousSibling) {
          currentButton.parentElement.previousSibling.querySelector('button').click();
        }
      }
    });
  });
}

/* ---- Cart slider ---- */
function initSlider(container, itemsPerViewDesktop, itemsPerViewMobile) {
  const slider = document.querySelector(container);
  if (!slider) return;

  let index = 0;
  const slides = slider.querySelectorAll(".slider__slide");
  const totalSlides = slides.length;
  const nextButton = slider.querySelector(".button-slide_next");
  const prevButton = slider.querySelector(".button-slide_prev");
  const buttonContainer = slider.querySelector(".product_cross_sells_button");
  const productsList = slider.querySelector(".products_list");

  function getItemsPerView() {
    return window.innerWidth <= 768 ? itemsPerViewMobile : itemsPerViewDesktop;
  }

  function updateNavigationVisibility() {
    const itemsPerView = getItemsPerView();

    if (totalSlides > itemsPerView) {
      if (buttonContainer) buttonContainer.style.display = "";
      if (prevButton)
        prevButton.classList.toggle("disabled", index <= 0);
      if (nextButton)
        nextButton.classList.toggle("disabled", index >= totalSlides - itemsPerView);
    } else {
      if (buttonContainer) buttonContainer.style.display = "none";
    }
  }

  function showSlide() {
    const itemsPerView = getItemsPerView();
    index = Math.max(0, Math.min(index, totalSlides - itemsPerView));

    const translateX = -(index * (100 / itemsPerView));
    if (productsList) {
      productsList.style.transform = `translateX(${translateX}%)`;
    }

    updateNavigationVisibility();
  }

  if (nextButton) {
    nextButton.addEventListener("click", () => {
      if (nextButton.classList.contains("disabled")) return;
      index++;
      showSlide();
    });
  }

  if (prevButton) {
    prevButton.addEventListener("click", () => {
      if (prevButton.classList.contains("disabled")) return;
      index--;
      showSlide();
    });
  }

  window.addEventListener("resize", () => {
    showSlide();
    updateNavigationVisibility();
  });

  updateNavigationVisibility();
  showSlide();
}

/* ---- Order note toggle ---- */
function initOrderNoteToggle() {
  const orderNoteToggle = document.querySelector(".order-note-toggle");
  const orderNoteContent = document.querySelector(".order-note-content");
  const orderNoteOverlay = document.querySelector(".order-note-overlay");

  if (orderNoteToggle) {
    orderNoteToggle.addEventListener("click", () => {
      if (orderNoteContent) orderNoteContent.classList.add("active");
      if (orderNoteOverlay) orderNoteOverlay.classList.add("active");
      document.body.style.overflow = "hidden";
    });
  }

  document.querySelectorAll(".close-note, .order-note-overlay, .save-note").forEach((el) => {
    el.addEventListener("click", () => {
      if (orderNoteContent) orderNoteContent.classList.remove("active");
      if (orderNoteOverlay) orderNoteOverlay.classList.remove("active");
      document.body.style.overflow = "auto";
    });
  });
}

/* ---- Quantity minus button handler (delegated) ---- */
function initQuantityHandler() {
  document.body.addEventListener("click", (e) => {
    if (e.target.matches('.box-cart .cart-item__quantity [name="minus"]')) {
      const cartQuantity = e.target.closest(".cart-quantity");
      const input = cartQuantity?.querySelector(".quantity__input");
      let value = parseFloat(input?.value || 0);

      if (value === 0) {
        e.target.style.display = "none";
        const cartItem = e.target.closest(".cart-item");
        if (cartItem) cartItem.remove();
      }
    }
  });
}

/* ---- Move freeshipping bar on resize ---- */
function moveFreeshippingBar() {
  const freeshippingBar = document.querySelector('.box-total #cart-free-shipping-threshold');
  const titleWrapper = document.querySelector('.title-wrapper-with-link');
  const originalParent = document.querySelector('.box-total .js-contents');
  if (!freeshippingBar || !titleWrapper || !originalParent) return;

  function handleResize() {
    if (window.innerWidth < 750) {
      const cartHeading = titleWrapper.querySelector('.cart_heading');
      if (cartHeading && !titleWrapper.querySelector('.freeshipping-bar')) {
        cartHeading.insertAdjacentElement('afterend', freeshippingBar);
      }
    } else {
      if (titleWrapper.querySelector('.freeshipping-bar')) {
        originalParent.insertBefore(freeshippingBar, originalParent.firstChild);
      }
    }
  }

  handleResize();
  window.addEventListener('resize', handleResize);
}

/* ---- Free shipping message (global — called by other scripts) ---- */
function updateFreeShippingMessage() {
  const bars = document.querySelectorAll(".freeshipping-bar");

  bars.forEach($el => {
    if (!$el) return;

    $el.classList.add("loading");

    const currency = $el.dataset.currency;
    const freeShippingThresholdBase = parseFloat($el.dataset.freeShippingThreshold);
    const cartTotal = Number($el.dataset.cartTotal) / 100;

    const messageEl = $el.querySelector(".freeshipping-message");
    const achievedMessage = messageEl.dataset.achievedMessage;
    const notAchievedTemplate = messageEl.dataset.notAchievedMessage;

    const rate = Number(window.Shopify.currency.rate);
    const freeShippingThreshold = freeShippingThresholdBase * rate;
    const remaining = freeShippingThreshold - cartTotal;
    const progress = Math.min((cartTotal / freeShippingThreshold) * 100, 100);

    $el.setAttribute("data-rate", rate);

    if (remaining <= 0) {
      messageEl.textContent = achievedMessage;
    } else {
      const formattedRemaining = remaining.toLocaleString(
        currency === "VND" ? "vi-VN" : "en-US",
        { style: "currency", currency }
      );
      messageEl.textContent = notAchievedTemplate.replace("__PLACEHOLDER__", formattedRemaining);
    }

    const progressEl = $el.querySelector(".progress");
    if (progressEl) {
      progressEl.style.width = progress + "%";
    }

    setTimeout(() => {
      $el.classList.remove("loading");
    }, 10);
  });
}

/* ---- Initialize on DOMContentLoaded ---- */
document.addEventListener("DOMContentLoaded", () => {
  sliderArrowPosition();
  productImageDesktopArrow();

  initSlider(".cart-drawer", 1, 1);
  initSlider(".cart-notification", 4, 2);

  initOrderNoteToggle();
  initQuantityHandler();
  moveFreeshippingBar();
  updateFreeShippingMessage();
});

window.addEventListener("resize", () => {
  sliderArrowPosition();
});